/**
 * PostHog Page View Tracker
 *
 * Captures page views on route changes using React Router hooks.
 */

import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

export function PostHogPageView() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    if (location.pathname && posthog) {
      let url = window.origin + location.pathname;
      const search = searchParams.toString();
      if (search) {
        url = url + `?${search}`;
      }
      posthog.capture("$pageview", { $current_url: url });
    }
  }, [location.pathname, searchParams, posthog]);

  return null;
}
